/* A11y fixes - EPF Jewelry */
(function () {
  var queued = false;

  // 1. Flickity page dots: hidden text inside each <li> (fixes "Empty list item")
  function fixFlickityDots() {
    document.querySelectorAll('.flickity-page-dots .dot').forEach(function (dot) {
      if (dot.querySelector('.visually-hidden')) return;
      var label = dot.getAttribute('aria-label') ||
        ('Slide ' + (Array.prototype.indexOf.call(dot.parentNode.children, dot) + 1));
      var span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = label;
      dot.appendChild(span);
    });
  }

  // 2. Product slideshow: remove Flickity's tabindex
  function fixSlideshowTabindex() {
    document.querySelectorAll('[data-product-slideshow][tabindex]').forEach(function (el) {
      el.removeAttribute('tabindex');
    });
  }

  // 3. Tabs (product tabs, related/recent, size chart): tablist / tab / tabpanel + aria links
  var tabUid = 0;
  function fixTabs() {
    document.querySelectorAll('ul.tabs').forEach(function (ul) {
      if (!ul.querySelector('.tab-link')) return;
      var holder = ul.closest('[data-tabs-holder]') || ul.parentNode;
      ul.setAttribute('role', 'tablist');

      ul.querySelectorAll('.tab-link').forEach(function (li) {
        li.setAttribute('role', 'tab');
        li.setAttribute('aria-selected', li.classList.contains('current') ? 'true' : 'false');

        if (!li.dataset.a11yId) li.dataset.a11yId = 'a11y-tab-' + (++tabUid);
        if (!li.id) li.id = li.dataset.a11yId;

        var panel = holder.querySelector('.tab-content-' + li.getAttribute('data-tab'));
        if (!panel) return;
        if (!panel.id) panel.id = li.dataset.a11yId + '-panel';
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', li.id);
        li.setAttribute('aria-controls', panel.id);
      });
    });
  }

  // 4. Accordions (Shipping etc.): button role + aria-expanded
  function fixAccordions() {
    document.querySelectorAll('[data-accordion-toggle]').forEach(function (t) {
      t.setAttribute('role', 'button');
      var body = t.parentNode.querySelector('[data-accordion-body]');
      if (body) t.setAttribute('aria-expanded', body.offsetHeight > 0 ? 'true' : 'false');
    });
  }

  // 5. Nested lists in RTE content: unwrap outer <ul>/<ol> that has no direct <li>
  function fixNestedLists() {
    document.querySelectorAll('.rte ul > ul, .rte ul > ol, .rte ol > ul, .rte ol > ol').forEach(function (inner) {
      var outer = inner.parentNode;
      if (!outer || !outer.parentNode || outer.querySelector(':scope > li')) return;
      while (outer.firstChild) outer.parentNode.insertBefore(outer.firstChild, outer);
      outer.remove();
    });
  }

  // 6. Form landmarks: accessible names (fallback where Liquid form tag drops aria-label)
  function fixFormLabels() {
    var map = [
      ['[data-newsletter-form]', 'Newsletter signup'],
      ['[data-collection-filters-form]', 'Product filters'],
      ['[data-product-form]', 'Purchase options']
    ];
    map.forEach(function (item) {
      document.querySelectorAll(item[0]).forEach(function (form) {
        if (form.tagName === 'FORM' && !form.hasAttribute('aria-label') && !form.hasAttribute('aria-labelledby')) {
          form.setAttribute('aria-label', item[1]);
        }
      });
    });
  }

  // 7. Product thumbnails: unique link names ("<alt> - image X of Y")
  function fixThumbLinks() {
    document.querySelectorAll('[data-product-thumbs]').forEach(function (wrap) {
      var links = wrap.querySelectorAll('a[data-thumbnail]');
      links.forEach(function (a, i) {
        var img = a.querySelector('img');
        var base = (img && img.getAttribute('alt')) || 'Product';
        a.setAttribute('aria-label', base + ' - image ' + (i + 1) + ' of ' + links.length);
      });
    });
  }

  // 8. Itoris Dynamic Product Options app: layout tables + unlabeled selects
  function fixProductOptionsApp() {
    var root = document.getElementById('itoris_dynamicproductoptions');
    if (!root) return;

    root.querySelectorAll('table').forEach(function (t) {
      if (!t.querySelector('th')) t.setAttribute('role', 'presentation');
    });

    root.querySelectorAll('select').forEach(function (sel) {
      if (sel.hasAttribute('aria-label') || sel.hasAttribute('aria-labelledby')) return;
      if (sel.id && root.querySelector('label[for="' + sel.id + '"]')) return;
      var p = sel.parentElement, lbl = null, n = 0;
      while (p && p !== root && n < 5 && !lbl) {
        lbl = p.querySelector('label');
        p = p.parentElement;
        n++;
      }
      if (lbl) {
        var text = lbl.textContent.replace(/\*/g, '').trim();
        if (text) sel.setAttribute('aria-label', text);
      }
    });
  }

  // 9. Brick/standard CTA buttons ("SHOP NOW"): aria-label = visible text + block heading
  function fixCtaLinks() {
    document.querySelectorAll('a.standard__cta').forEach(function (a) {
      if (a.dataset.a11yCta) return;
      var p = a.parentElement, heading = null, n = 0;
      while (p && n < 4 && !heading) {
        heading = p.querySelector('.standard__heading');
        p = p.parentElement;
        n++;
      }
      var visible = a.textContent.replace(/\s+/g, ' ').trim();
      var text = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!visible) return;
      a.setAttribute('aria-label', text ? visible + ' - ' + text : visible);
      a.dataset.a11yCta = '1';
    });
  }

  // 10. Hero buttons hidden by AOS before animation: lock name via aria-label
  function fixAosLinkNames() {
    document.querySelectorAll('a.hero__btn[data-aos]:not(.standard__cta)').forEach(function (a) {
      if (a.hasAttribute('aria-label')) return;
      var text = a.textContent.replace(/\s+/g, ' ').trim();
      if (text) a.setAttribute('aria-label', text);
    });
  }

  // 11. Klaviyo teaser ("15% OFF"): accessible name for role=button span
  function fixKlaviyoTeaser() {
    document.querySelectorAll('[class*="kl-teaser"] [role="button"]').forEach(function (btn) {
      if (btn.getAttribute('aria-label')) return;
      var text = btn.textContent.replace(/\s+/g, ' ').trim();
      btn.setAttribute('aria-label', (text || '15% OFF') + ' - open signup form');
    });
  }

  // 12. Cart quantity controls: unique names per line + aria-label on icon buttons
  function fixCartQtyNames() {
    document.querySelectorAll('[data-quantity-holder]').forEach(function (holder, i) {
      if (!holder.querySelector('[name="updates[]"]')) return;
      holder.querySelectorAll('[title]').forEach(function (el) {
        if (!el.dataset.a11yBaseTitle) el.dataset.a11yBaseTitle = el.getAttribute('title');
        var name = el.dataset.a11yBaseTitle + ' (item ' + (i + 1) + ')';
        el.setAttribute('title', name);
        if (el.tagName === 'BUTTON') el.setAttribute('aria-label', name);
      });
    });
  }

  // 13. Icon-only buttons with aria-label: add matching hidden text
  function fixIconButtons() {
    document.querySelectorAll('button[aria-label]').forEach(function (b) {
      if (b.querySelector('.a11y-btn-text')) return;
      if (b.textContent.replace(/\s+/g, '').length) return;
      var span = document.createElement('span');
      span.className = 'visually-hidden a11y-btn-text';
      span.textContent = b.getAttribute('aria-label');
      b.appendChild(span);
    });
  }

  // 14. Hidden SVG icons: drop role="presentation" (conflicts with aria-hidden)
  function fixSvgRoles() {
    document.querySelectorAll('svg[aria-hidden="true"][role="presentation"]').forEach(function (s) {
      s.removeAttribute('role');
    });
  }

    // 15. Empty links (<a href></a>): no text, no URL — remove from page
  function fixEmptyLinks() {
    document.querySelectorAll('a[href=""], a[href]:not([href*="/"]):not([href*="#"]):not([href*=":"])').forEach(function (a) {
      if (a.getAttribute('href').trim() !== '') return;
      if (a.children.length || a.textContent.trim() || a.getAttribute('aria-label')) return;
      a.remove();
    });
  }

    // 16. Fallback H1: if page has no <h1>, add a visually hidden one from the page title
  function fixMissingH1() {
    if (document.querySelector('h1')) return;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    var title = document.title.split(/\s[–\-|]\s/)[0].trim() || 'EPF Jewelry';
    var h1 = document.createElement('h1');
    h1.className = 'visually-hidden';
    h1.textContent = title;
    main.insertBefore(h1, main.firstChild);
  }

  function runAll() {
    queued = false;
    fixMissingH1();
    fixEmptyLinks();
    fixSvgRoles();
    fixCartQtyNames();
    fixIconButtons();
    fixAosLinkNames();
    fixKlaviyoTeaser();
    fixCtaLinks();
    fixProductOptionsApp();
    fixThumbLinks();
    fixFormLabels();
    fixNestedLists();
    fixFlickityDots();
    fixSlideshowTabindex();
    fixTabs();
    fixAccordions();
    // add future fixes here
  }

  function queue() {
    if (!queued) { queued = true; requestAnimationFrame(runAll); }
  }

  function init() {
    runAll();

    // Re-run when DOM changes or Flickity re-adds tabindex
    new MutationObserver(queue).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['tabindex']
    });

    // Update aria-selected / aria-expanded after tab or accordion interaction
    ['click', 'keyup'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (e.target.closest && e.target.closest('.tab-link, [data-accordion-toggle]')) {
          setTimeout(queue, 400);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();